module.exports = __webpack_public_path__ + "2f4bfa89b632f95f1009897cf2a56fb5.pdf";